import React, { FC, useMemo } from 'react';
import { IonButtons, IonIcon, IonTitle } from '@ionic/react';
import { arrowBackOutline } from 'ionicons/icons';
import ProgressBar from '../../../../components/ProgressBar';
import { OnBoardingMap } from '../../../../redux/onBoarding/types';
import { useSelector } from 'react-redux';
import { getCurrentStep, getOnBoardingMap, getPreviewSteps } from '../../../../redux/onBoarding/selector';
import { AppHeaderStyled, BackButton } from './OnBoardingHeader.style';
import { useHistory } from 'react-router-dom';

type OnBoardingHeaderProps = {
  hideBackButton?: boolean;
};

const OnBoardingHeader: FC<OnBoardingHeaderProps> = ({ hideBackButton = false }) => {
  const history = useHistory();

  const currentStepSelector = useSelector(getCurrentStep);
  const previewSteps = useSelector(getPreviewSteps);
  const onBoardingMap = useSelector(getOnBoardingMap);

  const progress = useMemo(() => {
    const prevStepsCount = previewSteps?.length ?? 0;
    let nextStepsCount = -1;
    let countSuccess = false;

    const iter = (s: OnBoardingMap) => {
      if (s.type === currentStepSelector?.type && s.id === currentStepSelector?.id) {
        countSuccess = true;
      }

      if (countSuccess) {
        nextStepsCount++;
      }

      if (s?.answers?.length) {
        s.answers.forEach((a) => {
          if (a.next_steps?.length) {
            a.next_steps.some(iter);
          }
        });
      }

      if (s?.next_steps?.length) {
        s.next_steps.some(iter);
      }
    };

    onBoardingMap.some(iter);
    return (prevStepsCount * 100) / (nextStepsCount + prevStepsCount) / 100;
  }, [currentStepSelector, onBoardingMap]);

  return (
    <AppHeaderStyled>
      {!hideBackButton && (
        <IonButtons slot="start">
          <BackButton onClick={() => history.back()}>
            <IonIcon icon={arrowBackOutline} />
          </BackButton>
        </IonButtons>
      )}
      <IonTitle>
        <ProgressBar progress={progress} fullWidth />
      </IonTitle>
    </AppHeaderStyled>
  );
};

export default React.memo(OnBoardingHeader);
